import { render, staticRenderFns } from "./_LayoutLogado.vue?vue&type=template&id=15d2cac5&scoped=true&"
import script from "./_LayoutLogado.vue?vue&type=script&lang=js&"
export * from "./_LayoutLogado.vue?vue&type=script&lang=js&"
import style0 from "./_LayoutLogado.vue?vue&type=style&index=0&id=15d2cac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2cac5",
  null
  
)

export default component.exports